import React, { useState, useEffect, useContext, Component } from 'react';

import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import toast from "react-hot-toast";
import { Helmet } from 'react-helmet';
import Header from '../components/Header'
import Footer from '../components/Footer';
import axiosInstance from '../../axiosInstance';
import getDecryptData from '../../helper/getDecryptData';
import LoadingScreen from '../components/LoadingScreen';

const PatnerPage = () => {
 
const { slug } = useParams();
  const decryptdatajson = getDecryptData();

  const navigate = useNavigate();

    const [isLoading, setloading] = useState(true);
  
      const [Data, setData] = useState([]);



    const getPatner = async () => {
   
      setloading(true);
      try {
        const { data } = await axiosInstance.get(`/admin/get-home-category/${slug ?? ''}`);
     
        setData(data.Category || []);
        // Delay the execution of buildScript by 1 secon
        console.log('datadata',data);
       }
      catch (error) {
        console.log(error);
        // toast.error("Error fetching Single Blog!");
      } finally {
        setloading(false);
      }
  
  
    };
  
  
  
  
    useEffect(() => {
      getPatner();
      window.scrollTo(0, 0);
    }, [slug]);


  return (
    <>
      <Header />
      <Helmet>
        <title> User Partner </title>
        <meta name="metaDescription" content={'Create account & manage profile'} />
      </Helmet>
 

      <main className="page whitesmoke">
     
     {!isLoading ?
     <div className="user-dasboard bg-white">
  <div className="container pt-4">
    <div className="row pb-4 mt-4 pt-4">
    

      <div className="col-md-8">
        <h5 className="text-theme">Partner Program</h5>
        <h1>Signup as a {Data.title}</h1>
        <h4 className="text-theme">{Data.heading}</h4>

        <ul>
          <li>Launch your e-commerce side-business in minutes</li>
          <li>Access a ready product catalog & branded creatives</li>
          <li>Share, sell, and track with your own referral dashboard</li>
          <li>Cash out your profit share (60%) on every completed order</li>
          <li>Marketing toolkit, training & dedicated support</li>
          <li>No tech headaches—simple links, QR, and coupons</li>
        </ul>

        <a className="btn btn-primary" href="#partner">
          Join Now & Start Earning
        </a>
      </div>

        <div className="col-md-4">
        <img
          src="https://dam.buhlergroup.com/image/e54eab5b827e421988c998b19eeebdf2/-FJPG-C529x529%2C184%2C0-S2046x2026-S1024x1024"
          width="100%"
          alt="User Partner Program"
          className="border rounded"
        />
      </div>

      <div id="main-content" className="w-100">
        <div className="overflow-auto mt-4 pt-4">
          <br />
          <table className="table table-bordered">
            <thead>
              <tr>
                <th className="bg-light" style={{ maxWidth: "20%" }}>
                  Benefits / Plan
                </th>
                <th className="text-center bg-light">User Partner</th>
                <th className="text-center bg-light">Guest Shopper</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ maxWidth: "20%" }}>
                  Profit Share on Orders Generated by You
                </td>
                <td className="text-center">60% of profit</td>
                <td className="text-center">0%</td>
              </tr>
              <tr>
                <td style={{ maxWidth: "20%" }}>
                  Personal Dashboard (Links, Coupons, Analytics)
                </td>
                <td className="text-center">Yes</td>
                <td className="text-center">No</td>
              </tr>
              <tr>
                <td style={{ maxWidth: "20%" }}>
                  Marketing Toolkit (Banners, Reels, Copy Templates)
                </td>
                <td className="text-center">Included</td>
                <td className="text-center">—</td>
              </tr>
              <tr>
                <td style={{ maxWidth: "20%" }}>
                  Catalog Access (Top Sellers, New Launches, Offers)
                </td>
                <td className="text-center">Full Access</td>
                <td className="text-center">Shop Only</td>
              </tr>
              <tr>
                <td style={{ maxWidth: "20%" }}>
                  Payouts & Withdrawal (T+7 after delivery/return window)
                </td>
                <td className="text-center">Yes</td>
                <td className="text-center">—</td>
              </tr>
              <tr>
                <td style={{ maxWidth: "20%" }}>
                  Support (Chat/Email) & Onboarding Training
                </td>
                <td className="text-center">Priority</td>
                <td className="text-center">Standard</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Mission */}
        <div className="row mt-4">
          <div className="col-md-12 col-12 pb-4">
            <h2 className="text-center">OUR MISSION</h2>
          </div>
          <div className="text-center col-md-12 col-12 pb-4">
            <p
              className="p-2 m-0 rounded"
              style={{ background: "rgb(243 247 251)", height: "100%" }}
            >
              "We empower everyday creators and sellers to build a profitable
              e-commerce business with a fair 60% profit share, transparent
              tracking, and zero tech complexity."
            </p>
          </div>
        </div>

        {/* Vision */}
        <div className="row mt-4">
          <div className="col-md-12 col-12 pb-4">
            <h2 className="text-center">OUR VISION</h2>
          </div>
          <div className="text-center col-md-12 col-12 pb-4">
            <p
              className="p-2 m-0 rounded"
              style={{ background: "rgb(243 247 251)", height: "100%" }}
            >
              "To create India’s most trusted user-led commerce network where
              anyone can start, scale, and earn from their audience."
            </p>
          </div>
        </div>

      

        {/* Benefits */}
        <div className="row mt-4">
          <div className="col-md-12 col-12 pb-4">
            <h2 className="text-center">Why Become a User Partner?</h2>
          </div>

          <div className="col-md-4 col-12 mb-4">
            <div
              className="d-flex px-3 py-3 d-flex gap-2 align-items-center rounded blurbbg"
              style={{ background: "rgb(243 247 251)", height: "100%" }}
            >
              <img
                alt="High Earnings"
                width="40px"
                height="40px"
                src="https://cdn-icons-png.flaticon.com/512/5290/5290109.png"
              />
              <div className="col">
                <h5 className="text-dark">High Earnings</h5>
                <p className="fw-light text-grey p-0 m-0">
                  60% of profit on every completed order you generate.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-12 mb-4">
            <div
              className="d-flex px-3 py-3 d-flex gap-2 align-items-center rounded blurbbg"
              style={{ background: "rgb(243 247 251)", height: "100%" }}
            >
              <img
                alt="Simple Tools"
                width="40px"
                height="40px"
                src="https://cdn-icons-png.flaticon.com/512/5290/5290109.png"
              />
              <div className="col">
                <h5 className="text-dark">Simple Tools</h5>
                <p className="fw-light text-grey p-0 m-0">
                  Links, coupons & analytics—zero coding required.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-12 mb-4">
            <div
              className="d-flex px-3 py-3 d-flex gap-2 align-items-center rounded blurbbg"
              style={{ background: "rgb(243 247 251)", height: "100%" }}
            >
              <img
                alt="Reliable Payouts"
                width="40px"
                height="40px"
                src="https://cdn-icons-png.flaticon.com/512/5290/5290109.png"
              />
              <div className="col">
                <h5 className="text-dark">Reliable Payouts</h5>
                <p className="fw-light text-grey p-0 m-0">
                  Weekly withdrawals after delivery/return clearance.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* How it works */}
        <div className="row mt-4">
          <div className="col-md-12 col-12 pb-4">
            <h2 className="text-center">How It Works</h2>
          </div>

          <div className="col-md-4 col-12 mb-4">
            <div
              className="d-flex px-3 py-3 d-flex gap-2 align-items-center rounded blurbbg"
              style={{ background: "rgb(243 247 251)", height: "100%" }}
            >
              <img
                alt="Step 1"
                width="40px"
                height="40px"
                src="https://backend-2o7f.onrender.com/uploads/new/image-1740728115633.png"
              />
              <div className="col">
                <h5 className="text-dark">Step 1: Sign Up</h5>
                <p className="fw-light text-grey p-0 m-0">
                  Complete KYC & get your partner dashboard.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-12 mb-4">
            <div
              className="d-flex px-3 py-3 d-flex gap-2 align-items-center rounded blurbbg"
              style={{ background: "rgb(243 247 251)", height: "100%" }}
            >
              <img
                alt="Step 2"
                width="40px"
                height="40px"
                src="https://backend-2o7f.onrender.com/uploads/new/image-1740728115628.png"
              />
              <div className="col">
                <h5 className="text-dark">Step 2: Share & Sell</h5>
                <p className="fw-light text-grey p-0 m-0">
                  Pick products, share your links/QR/coupons.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-12 mb-4">
            <div
              className="d-flex px-3 py-3 d-flex gap-2 align-items-center rounded blurbbg"
              style={{ background: "rgb(243 247 251)", height: "100%" }}
            >
              <img
                alt="Step 3"
                width="40px"
                height="40px"
                src="https://backend-2o7f.onrender.com/uploads/new/image-1740728115652.png"
              />
              <div className="col">
                <h5 className="text-dark">Step 3: Earn & Withdraw</h5>
                <p className="fw-light text-grey p-0 m-0">
                  Orders complete → profit credited → withdraw weekly.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ */}
        <section className="my-4 py-4">
          <h3 className="text-start mb-3">Frequently Asked Questions</h3>
          <div className="accordion" id="accordionID0">
            <div className="accordion-item mb-2 border rounded overflow-hidden">
              <div className="accordion-header">
                <h4
                  className="accordion-button h3 collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne0"
                  aria-expanded="false"
                  aria-controls="collapseOne0"
                  style={{ fontSize: 20, fontWeight: 600 }}
                >
                  1. How do I earn 60% profit?
                </h4>
              </div>
              <div
                id="collapseOne0"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionID0"
              >
                <div className="accordion-body">
                  When a customer purchases using your link/QR/coupon, we track
                  the order. After delivery and return window closure, 60% of
                  the net profit is added to your wallet for withdrawal.
                </div>
              </div>
            </div>

            <div className="accordion-item mb-2 border rounded overflow-hidden">
              <div className="accordion-header">
                <h4
                  className="accordion-button h3 collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne1"
                  aria-expanded="false"
                  aria-controls="collapseOne1"
                  style={{ fontSize: 20, fontWeight: 600 }}
                >
                  2. Do I need to manage shipping or returns?
                </h4>
              </div>
              <div
                id="collapseOne1"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionID0"
              >
                <div className="accordion-body">
                  No. We handle order processing, delivery, and returns. You
                  focus on marketing and selling.
                </div>
              </div>
            </div>

            <div className="accordion-item mb-2 border rounded overflow-hidden">
              <div className="accordion-header">
                <h4
                  className="accordion-button h3 collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne2"
                  aria-expanded="false"
                  aria-controls="collapseOne2"
                  style={{ fontSize: 20, fontWeight: 600 }}
                >
                  3. What is the payout cycle?
                </h4>
              </div>
              <div
                id="collapseOne2"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionID0"
              >
                <div className="accordion-body">
                  Payouts are processed weekly (T+7 after delivery/returns).
                  You can withdraw to your bank or UPI once the wallet meets the
                  minimum threshold.
                </div>
              </div>
            </div>

            <div className="accordion-item mb-2 border rounded overflow-hidden">
              <div className="accordion-header">
                <h4
                  className="accordion-button h3 collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne3"
                  aria-expanded="false"
                  aria-controls="collapseOne3"
                  style={{ fontSize: 20, fontWeight: 600 }}
                >
                  4. Is GST mandatory?
                </h4>
              </div>
              <div
                id="collapseOne3"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionID0"
              >
                <div className="accordion-body">
                  GST is optional for joining. If you want GST invoices or plan
                  to scale, you can add GST later in your profile.
                </div>
              </div>
            </div>

            <div className="accordion-item mb-2 border rounded overflow-hidden">
              <div className="accordion-header">
                <h4
                  className="accordion-button h3 collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne4"
                  aria-expanded="false"
                  aria-controls="collapseOne4"
                  style={{ fontSize: 20, fontWeight: 600 }}
                >
                  5. What does “profit” mean here?
                </h4>
              </div>
              <div
                id="collapseOne4"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionID0"
              >
                <div className="accordion-body">
                  Profit = Selling price minus product, logistics, payment
                  gateway, and applicable platform costs. You receive 60% of
                  this amount for your orders.
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div> : <LoadingScreen/>
     }



      </main >
 
 
      <Footer />
    </>

  )
}

export default PatnerPage